import {CustomerOverviewComponent} from './customer-overview.component';
import {CustomerFormComponent} from './customer-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {CustomerContactFormComponent} from './customer-contact-form.component';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'customer',
    component: CustomerOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.customer.pageTitle',
      scopes: ['customer:read']
    }
  },
  {
    name: 'customer.add',
    component: CustomerFormComponent,
    future: true,
    data: {
      pageTitle: 'states.customer.add.pageTitle',
      scopes: ['customer:create']
    }
  },
  {
    name: 'customer.edit',
    component: CustomerFormComponent,
    future: true,
    data: {
      pageTitle: 'states.customer.edit.pageTitle',
      scopes: ['customer:update']
    }
  },
  {
    name: 'customer.edit.contact',
    component: CustomerContactFormComponent,
    future: true,
    data: {
      pageTitle: 'states.customer.edit.contact.add.pageTitle',
      scopes: ['contact:create']
    }
  },
  {
    name: 'customer.edit.contact.edit',
    component: CustomerContactFormComponent,
    future: true,
    data: {
      pageTitle: 'states.customer.edit.contact.edit.pageTitle',
      scopes: ['contact:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ]
})
export class CustomerRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer.routes.ts